/**
 * Do not edit directly
 * Generated on Tue, 15 Aug 2023 12:48:09 GMT
 */

export const primary50 = '#cce3ff';
export const primary300 = '#4c9dff';
export const primary500 = '#0067E5';
export const primary700 = '#00469c';
export const newPrimary = '#2D0066';
export const neutral50 = '#f5f7fa';
export const neutral300 = '#d6deea';
export const neutral500 = '#a2afb8';
export const neutral700 = '#586874';
export const neutral900 = '#1d2226';
export const secondary50 = '#e0c7ff';
export const secondary300 = '#9c4cff';
export const secondary500 = '#8019ff';
export const secondary700 = '#5600c0';
export const newSecondary = '#CAA1FF';
export const tertiary50 = '#ffecc7';
export const tertiary300 = '#ffc557';
export const tertiary500 = '#ffb21f';
export const tertiary700 = '#e49600';
export const success50 = '#cef2db';
export const success300 = '#71da96';
export const success500 = '#27964d';
export const success700 = '#1f7a3f';
export const warning50 = '#ffaf66';
export const warning300 = '#ff9533';
export const warning500 = '#ff7c02';
export const warning700 = '#cc6200';
export const error50 = '#ff99ac';
export const error300 = '#ff002d';
export const error500 = '#bd0023';
export const error700 = '#8f001a';
export const gradientTop = 'linear-gradient(90deg, #0067e5 0%, #4c9dff 25.55%, #ff002f 61.68%, #ff7c02 100%)'; // Used at the top of MSC UI
export const gradientBlue = 'linear-gradient(180deg, #cce3ff 0%, #cce3ff00 100%)'; // Used on Login Page background
export const boxShadow0 = '0px 4px 4px rgba(0, 0, 0, 0.1)'; // Extra small box shadow for Drawers
export const boxShadow1 = '0px 5px 15px rgba(0, 0, 0, 0.15)'; // Box shadow small
export const border1 = '1px solid #0067E5'; // Primary default border - 1px
export const fontFamiliesWhitney = 'Whitney,Helvetica,Arial,sans-serif';
export const fontSize0 = '10px';
export const fontSize1 = '12px';
export const fontSize2 = '14px';
export const fontSize3 = '16px';
export const fontSize4 = '18px';
export const fontSize5 = '24px';
export const fontSize6 = '35px';
export const fontSize7 = '45px';
export const fontSize8 = '70px';
export const fontSize9 = '150px';
export const letterSpacing0 = '-0.02em';
export const letterSpacing1 = '0em';
export const textDecorationUnderline = 'underline';
export const textDecorationNone = 'none';
export const baseWhite = '#ffffff';
export const baseBlack = '#000000';
export const display1 = '600 150px/180px Whitney,Helvetica,Arial,sans-serif'; // Large Display text - 150px
export const display2 = '600 70px/84px Whitney,Helvetica,Arial,sans-serif'; // Medium Display text - 70px
export const display3 = '400 45px/54px Whitney,Helvetica,Arial,sans-serif'; // Small Display text - 54px
export const headingH1 = '600 35px/42px Whitney,Helvetica,Arial,sans-serif'; // Heading 1 - 35px
export const headingH2 = '600 24px/30px Whitney,Helvetica,Arial,sans-serif'; // Heading 2 - 24px
export const headingH3 = '600 18px/28px Whitney,Helvetica,Arial,sans-serif'; // Heading 3 - 28px
export const headingH3Italic = '600 18px/28px Whitney,Helvetica,Arial,sans-serif'; // Heading 3 Italic - 18px
export const body1 = '400 16px/24px Whitney,Helvetica,Arial,sans-serif'; // Main Body text - 16px
export const body2 = '350 14px/24px Whitney,Helvetica,Arial,sans-serif'; // Secondary Body text - 14px
export const body1Italic = '400 16px/24px Whitney,Helvetica,Arial,sans-serif'; // Main Body text Italic - 16px
export const body1Semibold = '600 16px/24px Whitney,Helvetica,Arial,sans-serif'; // Main Body text Semibold - 16px
export const body1Link = '600 16px/24px Whitney,Helvetica,Arial,sans-serif'; // Main Body text Link - 16px
export const body2Italic = '400 14px/24px Whitney,Helvetica,Arial,sans-serif'; // Secondary Body text Italic - 14px
export const body2Semibold = '600 14px/24px Whitney,Helvetica,Arial,sans-serif'; // Secondary Body text Semibold - 14px
export const body2Link = '600 14px/24px Whitney,Helvetica,Arial,sans-serif'; // Secondary Body text Link - 14px
export const brandShadowBlue = 'rgba(0, 103, 229, 0.20)';
export const caption1 = '600 12px/18px Whitney,Helvetica,Arial,sans-serif'; // Small detail text - 12px
export const caption2 = '600 10px/18px Whitney,Helvetica,Arial,sans-serif'; // Extra small text - 10px
export const caption1Link = '600 12px/18px Whitney,Helvetica,Arial,sans-serif'; // Small detail text Link - 12px
export const caption2Link = '600 10px/18px Whitney,Helvetica,Arial,sans-serif'; // Extra small text Link - 10px
export const paragraphSpacing0 = '0';
export const textCaseNone = 'none';
export const paragraphIndent0 = '0px';
export const lineHeights0 = '180px';
export const lineHeights1 = '84px';
export const lineHeights2 = '54px';
export const lineHeights3 = '42px';
export const lineHeights4 = '30px';
export const lineHeights5 = '28px';
export const lineHeights6 = '24px';
export const lineHeights7 = '18px';
export const fontWeightsWhitney0 = '600';
export const fontWeightsWhitney1 = '400';
export const fontWeightsWhitney2 = '600';
export const fontWeightsWhitney3 = '400';
export const spacing1 = '4px';
export const spacing2 = '8px';
export const spacing3 = '16px';
export const spacing4 = '24px';
export const spacing5 = '32px';
export const spacing6 = '40px';
export const spacing7 = '56px';
export const spacing8 = '64px';
export const spacing9 = '80px';
export const spacing10 = '96px';
export const borderWidth0 = '0.5px'; // 0.5px border
export const borderWidth1 = '1px'; // 1px border
export const borderWidth2 = '2px'; // 2px border
export const border2 = '1px solid #4c9dff'; // Primary Hover border - 1px
export const border3 = '1px solid #00469c'; // Primary button Hover border - 1px
export const border4 = '2px solid #00469c'; // Status (bottom) border for Input Active - 2px
export const border5 = '2px solid #00469c'; // Primary Active border - 2px
export const border6 = '1px solid #f5f7fa'; // Lightest grey border for Disabled Secondary Button
export const border7 = '1px solid #d6deea'; // Light grey border - 1px
export const border8 = '2px solid #d6deea'; // Status (bottom) border for Input Default - 2px
export const border9 = '2px solid #a2afb8'; // Status (bottom) border for Input Hover - 2px
export const border10 = '1px  #586874'; // Dark grey border - 1px
export const border11 = '4px solid #586874'; // Left grey border for Info Alert - 4px
export const border12 = '4px solid #1d2226'; // Black border (bottom) for Tabs - 4px
export const borderWidth3 = '4px'; // 4px border
export const border13 = '0.5px dashed #586874'; // Dashed dark grey border for Drap and drop workflow box - 0.5px
export const border14 = '1px dashed #a2afb8'; // Dashed grey border for Drap and drop workflow box - 1px
export const border15 = '2px solid #27964d'; // Status (bottom) border for Input Success - 2px
export const border16 = '4px solid #27964d'; // Left green border for Success Alert - 4px
export const border17 = '2px solid #ff7c02'; // Status (bottom) border for Input Warning - 2px
export const border18 = '4px solid #ff7c02'; // Left orange border for Warning Alert - 4px
export const border19 = '1px solid #bd0023'; // Error border - 1px
export const border20 = '2px solid #bd0023'; // Status (bottom) border for Input Error - 2px
export const border21 = '2px solid #bd0023'; // Error border - 2px
export const border22 = '4px solid #bd0023'; // Left red border for Error Alert - 4px
export const borderRadius1 = '8px'; // Border Radius - 8px
export const borderRadius2 = '16px'; // Border Radius - 16px
export const borderRadius3 = '24px'; // Border Radius - 24px
export const borderRadius4 = '50px'; // Border Radius - 50px
export const boxShadow2 = '0px 12px 34px rgba(0, 0, 0, 0.15)'; // Large box shadow
export const boxShadow3 =
  '0px 1px 4px rgba(0, 0, 0, 0.04), 0px 2px 12px rgba(0, 0, 0, 0.11), 0px 2px 12px rgba(0, 0, 0, 0.04), 0px 2px 12px rgba(0, 0, 0, 0.11)'; // Dashboard box shadows
export const boxShadow4 = '0px 5px 15px rgba(0, 103, 229, 0.1)'; // Small blue box shadow
export const boxShadow5 = '0px 12px 34px rgba(0, 103, 229, 0.2)'; // Large blue box shadow
export const boxShadow6 = '0px 5px 15px #FFECC7'; // Small yellow box shadow
export const boxShadow7 = '0px 12px 34px #FFECC7'; // Large yellow box shadow
export const boxShadow8 = '0px 5px 15px rgba(189, 0, 35, 0.1)'; // Small red box shadow
export const boxShadow9 = '0px 12px 34px #FF99AC'; // Large red box shadow
export const boxShadow10 = '0px 5px 15px rgba(39, 150, 77, 0.15)'; // Small green box shadow
export const boxShadow11 = '0px 12px 34px #CEF2DB'; // Large green box shadow
export const boxShadow12 = '0px 5px 15px rgba(224, 199, 255, 0.5)'; // Small purple box shadow
export const boxShadow13 = '0px 12px 34px #E0C7FF'; // Large purple box shadow
export const breakpointS = '576px'; // Small devices (landscape phones, 576px and up)
export const breakpointM = '768px'; // Medium devices (tablets, 768px and up)
export const breakpointL = '992px'; // Large devices (desktops, 992px and up)
export const breakpointXl = '1200px'; // X-Large devices (large desktops, 1200px and up)
export const breakpointXxl = '1400px'; // XX-Large devices (larger desktops, 1400px and up)
